import styled from 'styled-components'

export const BrandTitle = styled.span`
	font-size: 22px;
	line-height: 26px;
`
